module.exports = __webpack_public_path__ + "img/ico-google-circle.ff0fcb59.png";